module.exports = __webpack_public_path__ + "static/media/Alex Lu.f633bb77.JPG";